import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import http from '@/utils/http';
import { ElLoading } from 'element-plus';
import { message } from '@/utils/restMessage.js';
import { Plus } from '@element-plus/icons-vue';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
export default {
  components: {
    Plus: Plus
  },
  data: function data() {
    return {
      locale: zhCn,
      //国际化，组件英文汉化
      urlList: [],
      //图片上传数据
      sfjcxs: 1,
      //是否接触过销售
      sfjcsh: 1,
      //是否接触售后
      cpdd: [],
      //产品数据
      xzindex: -1,
      //点击分数选中
      position: '',
      //职位
      bwidth: true,
      //表单宽度
      phoneShow: true,
      //二维码状态
      imgStatus: false,
      //图片状态
      titleSize: 24,
      //标题大小
      mainpadding: 20,
      //整体边距
      radioShow: false,
      radio: false,
      //单选按钮
      zwData: ['设备管理部', '工艺工程部', '采购部', '生产部', '品质品控部', '仓库管理部', 'IT', '管理'],
      //职位
      bus: {
        // type:1,//售后调研
        openid: '',
        company: '',
        //公司
        contact: '',
        //联系人
        phone: '',
        //联系电话
        email: '',
        //邮箱
        position: '',
        //职位
        payurl: '' //图片
        // booktime:'',//预约时间

      }
    };
  },
  created: function created() {
    this.$route.query;

    if (this.$route.query.openid) {
      //openid
      this.bus.openid = this.$route.query.openid;
    }

    var company = this.$route.query.company;

    if (company != null && company != 'undefined') {
      //公司名称
      this.bus.company = this.$route.query.company;
    }

    if (this.$route.query.phone) {
      //电话
      this.bus.phone = this.$route.query.phone;
    }

    if (this.$route.query.contact) {
      //联系人
      this.bus.contact = this.$route.query.contact;
    }

    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      this.titleSize = 17;
      this.mainpadding = 0;
      this.bwidth = false;
      this.phoneShow = false;
    }
  },
  methods: {
    //图片上传成功了
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      console.log(res, file, '图片上传成功了');
      this.bus.payurl = res.data;
    },
    // 点击选中
    djxz: function djxz(index) {
      this.xzindex = index;
      this.bus.singlechoice13 = index;
    },
    // 点击显示图片
    tuShow: function tuShow() {
      this.imgStatus = true;
    },
    // 验证规则
    srule: function srule() {
      var _this$bus = this.bus,
          company = _this$bus.company,
          contact = _this$bus.contact,
          phone = _this$bus.phone,
          email = _this$bus.email,
          position = _this$bus.position; // 公司名称

      if (company == '') {
        message({
          type: "error",
          message: '公司名称不能为空'
        });
        return false;
      } // 联系人


      if (contact == '') {
        message({
          type: "error",
          message: '联系人不能为空'
        });
        return false;
      }

      var regPhone = /^[1][3-9][0-9]{9}$/; //手机正则
      // 电话

      if (phone == '') {
        message({
          type: "error",
          message: '联系电话不能为空'
        });
        return false;
      }

      if (!regPhone.test(phone)) {
        message({
          type: "error",
          message: '请输入正确的联系电话'
        });
        return false;
      }

      var regEMail = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/; //邮箱正则
      // 邮箱

      if (email == '') {
        message({
          type: "error",
          message: '邮箱不能为空'
        });
        return false;
      }

      if (!regEMail.test(email)) {
        message({
          type: "error",
          message: '请输入正确的邮箱号'
        });
        return false;
      } // 职位


      if (position == '' && this.position == '') {
        message({
          type: "error",
          message: '职位不能为空'
        });
        return false;
      } // 预约时间
      // if (booktime=='') {
      //     message({ type: "error", message: '预约时间不能为空' });
      //     return false
      // }
      // 付款截图


      if (this.urlList.length == 0) {
        message({
          type: "error",
          message: '付款截图不能为空'
        });
        return false;
      }

      return true;
    },
    // 点击提交
    busAdd: function busAdd() {
      var _this = this;

      if (!this.srule()) {
        return false;
      } // return
      // 遮罩层


      var loading = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      http.post("/ksfbooksignup/save", this.bus).then(function (res) {
        var _res$data = res.data,
            code = _res$data.code,
            description = _res$data.description;
        console.log(res);

        if (200 == code) {
          loading.close();
          message({
            type: "success",
            message: '提交成功！'
          }); //成功后清空数据

          for (var key in _this.bus) {
            _this.bus[key] = '';
          }

          _this.urlList = [];
        } else {
          loading.close();
          message({
            type: "error",
            message: description
          });
        }
      }).catch(function (err) {
        loading.close();
        message({
          type: "error",
          message: '服务器错误，请联系管理员'
        });
      });
    }
  }
};